import { InstructionStep } from './InstructionStep';

interface Props {
  images: string[];
  instructions: string[][];
}

export const Instructions = ({ images, instructions }: Props) => (
  <>
    {instructions.map((textParts, index) => (
      <InstructionStep
        key={index}
        textParts={textParts}
        imageSrc={images[index]}
      />
    ))}
  </>
);
